import { F_MapMarkerIndoorStandFragment } from '__generated__v2/graphql';
import { IndoorStandMarkersSymbol } from 'pages/special/OsloDesignFair/map/mapContent/Markers/IndoorStandMarkers/IndoorStandMarkersSymbol';
import { IndoorStandMarkersWall } from 'pages/special/OsloDesignFair/map/mapContent/Markers/IndoorStandMarkers/IndoorStandMarkersWall';

interface Props {
    markers: F_MapMarkerIndoorStandFragment[];
}

export const IndoorStandMarkers = (props: Props) => {
    return (
        <>
            <IndoorStandMarkersWall markers={props.markers} />
            <IndoorStandMarkersSymbol markers={props.markers} />
        </>
    );
};
